import { STOP_ACTION } from '../../providers/param/registry-keys.js';
import { ParamRegistry } from '../../registries/param-registry.js';
import { PreHandlers } from '../../registries/pre-handler-registry.js';

/**
 * 可用于停止中间件流程的方法
 *
 * @public
 * @decorator
 */
function StopAction() {
    return ParamRegistry.decorate(STOP_ACTION);
}
PreHandlers.set(STOP_ACTION, ({ runner }) => runner.stop.bind(runner));

export { StopAction };
//# sourceMappingURL=stop-action.js.map
